import {ContestTaskType} from './ContestTask';
import {Locale} from '../Locale';

export enum ContestEventType {
  start = 'start',
  answer = 'answer',
  finish = 'finish',
}

export const QUESTION_INDEX_COMPARATOR = (i1: ContestEvent, i2: ContestEvent) => !i1 || !i2 ? 0 : (i1.questionIndex || 0) - (i2.questionIndex || 0);

export class ContestProgress {

  public taskId?: string;

  public taskType?: ContestTaskType;

  public taskLocale?: Locale;

  public contestId: string;

  public contestDuration?: number;

  public startedAt?: Date;

  public finishedAt?: Date;

  public answers: Record<string, string[]>;


  constructor(contestId: string) {
    this.contestId = contestId;
    this.answers = {};
  }

  public static parse(dto: ContestProgressDto): ContestProgress {
    const progress = new ContestProgress(dto.contest_id);

    progress.taskId = dto.task_id;
    progress.taskType = dto.task_type;
    progress.taskLocale = dto.task_locale;
    progress.contestDuration = dto.contest_duration;
    if (dto.started_at) progress.startedAt = new Date(dto.started_at);
    if (dto.finished_at) progress.finishedAt = new Date(dto.finished_at);
    if (dto.answers) progress.answers = dto.answers;

    return progress;
  }
}

export interface ContestProgressDto {

  task_id?: string;

  task_type?: ContestTaskType;

  task_locale?: Locale;

  contest_id: string;

  contest_duration: number;

  started_at?: number;

  finished_at?: number;

  answers: Record<string, string[]>;
}

export class ContestEvent {

  public taskId: string;

  public taskType: ContestTaskType;

  public eventType: ContestEventType;

  public createdAt?: Date;

  public sectionIndex?: number;
  public questionIndex?: number;

  public answers?: string[];
  public answerIndexes?: number[];
  public correctAnswerIndexes?: number[];

  public points?: number;

  constructor(taskId: string, taskType: ContestTaskType, eventType: ContestEventType) {
    this.taskId = taskId;
    this.taskType = taskType;
    this.eventType = eventType;
  }

  public static parse(dto: ContestEventDto): ContestEvent {
    const event = new ContestEvent(dto.task_id, dto.task_type, dto.event_type);

    if (dto.created_at) event.createdAt = new Date(dto.created_at);

    if (dto.section_index) event.sectionIndex = dto.section_index;
    if (dto.question_index) event.questionIndex = dto.question_index;

    if (dto.answers) event.answers = dto.answers || [];
    if (dto.answer_indexes) event.answerIndexes = dto.answer_indexes || [];
    if (dto.correct_answer_indexes) event.correctAnswerIndexes = dto.correct_answer_indexes || [];

    if (dto.points) event.points = dto.points || 0;

    return event;
  }

}

export interface ContestEventDto {
  task_id: string;
  task_type: ContestTaskType;
  event_type: ContestEventType;
  created_at?: number;
  section_index?: number;
  question_index?: number;
  answers?: string[];
  answer_indexes?: number[];
  correct_answer_indexes?: number[];
  points?: number;
}

export interface ContestEventData {
  locale: Locale;
  section_index?: number;
  question_id?: string;
  answers?: string[];
  client_time?: number;
  school?: {
    id: string;
    name: string;
    short_name?: string;
    type: string;
  };
}
